import React from 'react'
import GoogleSlidesCaseStudy from '../templates/GoogleSlidesCaseStudy'
import SlideDeck from '../../../assets/decks/tropicana_case-study_master.pdf'

const Work = () => (
  <GoogleSlidesCaseStudy
    pageTitle="Truck delivery app"
    date="2021-2022"
    role="Designer & Consultant"
    company="Tropicana"
    presentationId="2PACX-1vSQX_c_OFzldzALOi2GBqezX6vbYpiKETEo1U1nxtBf9yrSLyxdQzkqtsi-SB_BGA"
    pdfLink={SlideDeck}
    figmaLink="https://www.figma.com/proto/WREUqo1jXYqqlYw6e3tzvX/Tropicana-Tracker?page-id=1442%3A4421&node-id=1442-4422&viewport=265%2C512%2C0.19&t=ZhNdbzl7hGxPnnY9-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=1442%3A4422&show-proto-sidebar=1"
  />
)

export default Work;
